import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { FC, useMemo } from 'react';
import { Checkbox, Col, Input, InputNumber, Radio, Row, Space } from 'udesk-ui';
import Frequency from 'src/components/common/Frequency';
import { AppealConfigModeMap, SamplePeriodModeMap } from './const';

interface TemplateProps {
    isTicket?: boolean;
    isComment?: boolean;
    disabled?: boolean;

    value?: {
        inspectionOptionsExport?: any;
        inspectionOptionsList?: any[];
        spoktOptions?: any;
        fastSampleInDetailList?: any;
        spoketOptionsExport?: any;
        spoktOptionsList?: any[];
        reviewOptions?: any;
        reviewOptionsExport?: any;
        reviewOptionsList?: any[];
        complainPeriodMode?: any;
        permitComplainCount?: any;
        complainPeriod?: any;
        reviewAging?: any;
        refreshComplainPeriodAndNum?: any;
        complainCycle?: any;
        complainScope?: any;
        complainDeadTime?: any;
        reviewCycle?: any;
        reviewScope?: any;
        reviewDeadTime?: any;
        complainDeadCount?: any;
        samplePeriodMode?: number;
        sampleAging?: number;
        sampleCycle?: number;
        sampleScope?: number;
        sampleDeadTime?: string;
        appealOptionsExport?: any;
        appaelable?: any;
        callDetailShowConfigList?: any;
        callDetailShowConfigOption?: any[];
        overSecondsDurationShow?: any;
        remarkModel?: any;
        finalReview?: any;
        sdkShowCaseLibrary?: number;
    };
    onValueChanged?: (key: string, e: any) => void;
    onAppealValueChanged: (e: any) => void;
    onAppealableChanged: (e: any) => void;
    callDetaiConfigChanged?: (e: any) => void;
    onRemarkModelChange?: (e: any) => void;
}

const Template: FC<TemplateProps> = (props) => {
    const {
        isTicket,
        isComment,
        disabled,
        value: {
            inspectionOptionsExport,
            inspectionOptionsList,
            spoktOptions,
            fastSampleInDetailList,
            spoketOptionsExport,
            spoktOptionsList,
            reviewOptions,
            reviewOptionsExport,
            reviewOptionsList,
            complainPeriodMode,
            permitComplainCount,
            complainPeriod,
            reviewAging,
            refreshComplainPeriodAndNum,
            appealOptionsExport,
            appaelable,
            callDetailShowConfigList,
            callDetailShowConfigOption,
            remarkModel,
            overSecondsDurationShow,
            complainCycle,
            complainScope,
            complainDeadTime,
            complainDeadCount,
            reviewCycle,
            reviewScope,
            reviewDeadTime,
            finalReview,
            sdkShowCaseLibrary,
            samplePeriodMode,
            sampleAging,
            sampleCycle,
            sampleScope,
            sampleDeadTime,
        } = {},
        onValueChanged,
        onAppealValueChanged,
        onAppealableChanged,
        callDetaiConfigChanged,
        onRemarkModelChange,
    } = props;

    const appealOptionsList = useMemo(
        () => [
            {
                label: UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                    .appealOptionsList.hiddenInspector,
                key: 'complainInspectorHidden',
            },
            {
                label: UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                    .appealOptionsList.hiddenHit,
                key: 'complainHighLightShow',
            },
        ],
        []
    );

    const appealableOptionsList = useMemo(
        () => [
            {
                label: /* AI质检结果可申诉 */ UdeskLocales['current'].pages.tasks.manage.template
                    .automaticAdd.components.businessConfig.index
                    .aIQualityInspectionResultsCanBeAppealed,
                key: 'enableComplainAiInspect',
            },
            {
                label: /* 人工抽检结果可申诉 */ UdeskLocales['current'].pages.tasks.manage.template
                    .automaticAdd.components.businessConfig.index
                    .theResultsOfManualSamplingCanBeAppealed,
                key: 'enableComplainManualInspect',
            },
        ],
        []
    );

    return (
        <>
            {/* 质检配置 */}
            {!isTicket && (
                <div className="automatic-content-item-body-item">
                    <div className="automatic-content-item-body-item-title">
                        {UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                            .qaDetailAction + '：'}
                    </div>

                    <div
                        className="automatic-content-item-body-item-content"
                        style={{ width: 'calc(100% - 132px)' }}
                    >
                        <div>
                            <Checkbox.Group
                                value={inspectionOptionsExport}
                                disabled={disabled}
                                style={{ width: '100%' }}
                                onChange={(e) => onValueChanged?.('inspectionOptionsExport', e)}
                            >
                                <Row>
                                    {inspectionOptionsList?.map((item) => {
                                        return (
                                            <Col span={24}>
                                                <Checkbox key={item.id} value={item.id}>
                                                    {item.name}
                                                </Checkbox>
                                            </Col>
                                        );
                                    })}
                                </Row>
                            </Checkbox.Group>
                        </div>
                    </div>
                </div>
            )}

            {/* 抽检配置 */}
            <div className="automatic-content-item-body-item">
                <div className="automatic-content-item-body-item-title">
                    {UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                        .spoktDetailAction + '：'}
                </div>

                <div
                    className="automatic-content-item-body-item-content"
                    style={{ width: 'calc(100% - 132px)', lineHeight: '30px' }}
                >
                    <div>
                        <Checkbox.Group
                            value={spoktOptions}
                            style={{ width: '100%' }}
                            disabled={disabled}
                            onChange={(e) => onValueChanged?.('spoktOptions', e)}
                        >
                            <Row>
                                {Udesk.enums.spoktListResultOptions.map((item) => {
                                    return (
                                        <Checkbox key={item.id} value={item.id}>
                                            {item.name}
                                        </Checkbox>
                                    );
                                })}
                            </Row>
                        </Checkbox.Group>
                    </div>

                    <div>
                        <Checkbox.Group
                            value={fastSampleInDetailList}
                            disabled={disabled}
                            style={{ width: '100%' }}
                            onChange={(e) => onValueChanged?.('fastSampleInDetailList', e)}
                        >
                            <Row>
                                {(() => {
                                    const list = Udesk.enums.fastSampleInDetailList || [];
                                    const reviewId =
                                        (Udesk.enums.fastSampleInDetailList as any)
                                            ?.fastSampleInReviewDetail?.id;
                                    const baseList = list.filter(
                                        (i: { id: number }) =>
                                            reviewId == null || i.id !== reviewId
                                    );
                                    // const hasOverdue = baseList.some(
                                    //     (i: { id: number }) => i.id === FastSampleInOverdueDetailId
                                    // );
                                    const options = baseList;
                                    return options.map((item: { id: number; name: string }) => (
                                        <Col span={8} key={item.id}>
                                            <Checkbox value={item.id}>{item.name}</Checkbox>
                                        </Col>
                                    ));
                                })()}
                            </Row>
                        </Checkbox.Group>
                    </div>

                    {!isTicket && (
                        <div>
                            <Checkbox.Group
                                value={spoketOptionsExport}
                                disabled={disabled}
                                style={{ width: '100%' }}
                                onChange={(e) => onValueChanged?.('spoketOptionsExport', e)}
                            >
                                <Row>
                                    {spoktOptionsList?.map((item) => {
                                        return (
                                            <Col span={8}>
                                                <Checkbox key={item.id} value={item.id}>
                                                    {item.name}
                                                </Checkbox>
                                            </Col>
                                        );
                                    })}
                                </Row>
                            </Checkbox.Group>
                        </div>
                    )}

                    {/* 抽检有效期/截止时间：单选 - 不设置有效期(默认)、设置抽检有效期、设置抽检截止时间 */}
                    <div style={{ marginTop: 12 }}>
                        <Radio.Group
                            value={
                                samplePeriodMode === SamplePeriodModeMap.SAMPLE_PERIOD ||
                                samplePeriodMode === SamplePeriodModeMap.SAMPLE_DEADLINE
                                    ? samplePeriodMode
                                    : SamplePeriodModeMap.None
                            }
                            onChange={(e) => onValueChanged?.('samplePeriodMode', e.target.value)}
                            disabled={disabled}
                        >
                            <Radio value={SamplePeriodModeMap.None}>
                                {
                                    /* 不设置有效期 */UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.components.businessConfig.index.dontSetValidityPeriod
                                }
                            </Radio>
                            <Radio value={SamplePeriodModeMap.SAMPLE_PERIOD}>
                                {
                                    /* 设置抽检有效期 */UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.components.businessConfig.index.setTheValidityPeriodOfRandomInspection
                                }
                            </Radio>
                            <Radio value={SamplePeriodModeMap.SAMPLE_DEADLINE}>
                                {
                                    /* 设置抽检截止时间 */UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.components.businessConfig.index.setTheDeadlineForRandomInspection
                                }
                            </Radio>
                        </Radio.Group>
                    </div>
                    {samplePeriodMode === SamplePeriodModeMap.SAMPLE_PERIOD && (
                        <div style={{ marginTop: 8, marginBottom: 8 }}>
                            <span>
                                {
                                    /* 抽检有效期 */UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.components.businessConfig.index.validityPeriodOfSamplingInspection
                                }
                            </span>
                            <InputNumber
                                value={sampleAging}
                                onChange={(e) => onValueChanged?.('sampleAging', e)}
                                disabled={disabled}
                                min={0}
                                precision={1}
                                style={{ marginLeft: 8, width: 120 }}
                            />
                            {UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                                .rewivewDays ?? /* 天 */UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.components.businessConfig.index.day}
                        </div>
                    )}
                    {samplePeriodMode === SamplePeriodModeMap.SAMPLE_DEADLINE && (
                        <div style={{ marginTop: 8, marginBottom: 8 }}>
                            <Space wrap>
                                <span>
                                    {
                                        /* 抽检截止时间 */UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.components.businessConfig.index.samplingDeadline
                                    }
                                </span>
                                <Frequency
                                    value={{
                                        frequency: sampleCycle,
                                        day: sampleScope,
                                        week: sampleScope,
                                        time: sampleDeadTime,
                                    }}
                                    onChange={(e) => {
                                        onValueChanged?.('sampleCycle', e?.frequency);
                                        onValueChanged?.(
                                            'sampleScope',
                                            e?.frequency ===
                                                Udesk.enums.assessFrequencyTypes.everyWeek.id
                                                ? e?.week
                                                : e?.day
                                        );
                                        onValueChanged?.('sampleDeadTime', e?.time);
                                    }}
                                />
                            </Space>
                        </div>
                    )}
                </div>
            </div>

            {/* 复核配置 */}
            {!isTicket && !isComment && (
                <div className="automatic-content-item-body-item">
                    <div className="automatic-content-item-body-item-title">
                        {UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                            .reviewDetailAction + '：'}
                    </div>

                    <div
                        className="automatic-content-item-body-item-content"
                        style={{ width: 'calc(100% - 132px)', lineHeight: '30px' }}
                    >
                        <div>
                            <Checkbox.Group
                                value={reviewOptions}
                                disabled={disabled}
                                style={{ width: '100%' }}
                                onChange={(e) => onValueChanged?.('reviewOptions', e)}
                            >
                                <Row>
                                    {Udesk.enums.reviewlistResultOptions
                                        .filter((i) => i.id !== 1)
                                        .map((item) => {
                                            return (
                                                <Col span={8}>
                                                    <Checkbox key={item.id} value={item.id}>
                                                        {item.name}
                                                    </Checkbox>
                                                </Col>
                                            );
                                        })}
                                </Row>
                            </Checkbox.Group>
                        </div>

                        <div>
                            <Checkbox.Group
                                value={reviewOptionsExport}
                                disabled={disabled}
                                style={{ width: '100%' }}
                                onChange={(e) => onValueChanged?.('reviewOptionsExport', e)}
                            >
                                <Row>
                                    {reviewOptionsList?.map((item) => {
                                        return (
                                            <Col span={8}>
                                                <Checkbox key={item.id} value={item.id}>
                                                    {item.name}
                                                </Checkbox>
                                            </Col>
                                        );
                                    })}
                                </Row>
                            </Checkbox.Group>
                        </div>
                    </div>
                </div>
            )}

            {/* 申诉配置 */}
            {!isComment ? (
                <div className="automatic-content-item-body-item">
                    <div className="automatic-content-item-body-item-title">
                        {UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                            .appealAction + '：'}
                    </div>

                    <div
                        className="automatic-content-item-body-item-content"
                        style={{
                            width: 'calc(100% - 132px)',
                            lineHeight: '30px',
                        }}
                    >
                        <div>
                            <Radio.Group
                                options={[
                                    {
                                        label: /* 设置申诉有效期 */ UdeskLocales['current'].pages
                                            .tasks.manage.template.automaticAdd.components
                                            .businessConfig.index.setAppealValidityPeriod,
                                        value: AppealConfigModeMap.Validity,
                                    },
                                    {
                                        label: /* 设置申诉截止时间 */ UdeskLocales['current'].pages
                                            .tasks.manage.template.automaticAdd.components
                                            .businessConfig.index.setAppealDeadline,
                                        value: AppealConfigModeMap.CutOff,
                                    },
                                ]}
                                value={complainPeriodMode}
                                onChange={(e) => onValueChanged?.('complainPeriodMode', e)}
                                disabled={disabled}
                            />
                        </div>

                        {complainPeriodMode === AppealConfigModeMap.Validity ? (
                            <div style={{ marginBottom: '10px' }}>
                                <span>
                                    <span>
                                        {/* 允许提交申诉次数 */}
                                        {
                                            UdeskLocales['current'].pages.tasks.manage.template
                                                .automaticAdd.templateNew
                                                .numberOfAppealsAllowedToBeSubmitted
                                        }
                                    </span>
                                    <span>
                                        <InputNumber
                                            value={permitComplainCount}
                                            onChange={(e) =>
                                                onValueChanged?.('permitComplainCount', e)
                                            }
                                            disabled={disabled}
                                        />
                                        {
                                            UdeskLocales['current'].pages.tasks.manage.template
                                                .automaticAdd.index.rewivewSecond
                                        }
                                    </span>
                                </span>
                                <span style={{ marginLeft: '20px' }}>
                                    <span>
                                        {/* 提交申诉有效期 */}
                                        {
                                            UdeskLocales['current'].pages.tasks.manage.template
                                                .automaticAdd.templateNew
                                                .validityOfSubmissionOfAppeal
                                        }
                                    </span>
                                    <span>
                                        <InputNumber
                                            value={complainPeriod}
                                            onChange={(e) => onValueChanged?.('complainPeriod', e)}
                                            disabled={disabled}
                                        />
                                        {
                                            UdeskLocales['current'].pages.tasks.manage.template
                                                .automaticAdd.index.rewivewDays
                                        }
                                    </span>
                                </span>
                                <span style={{ marginLeft: '20px' }}>
                                    <span>
                                        {/* 申诉复核有效期 */}
                                        {
                                            UdeskLocales['current'].pages.tasks.manage.template
                                                .automaticAdd.templateNew.validityOfAppealReview
                                        }
                                    </span>
                                    <span>
                                        <InputNumber
                                            value={reviewAging}
                                            onChange={(e) => onValueChanged?.('reviewAging', e)}
                                            // max={24}
                                            precision={1}
                                            disabled={disabled}
                                        />
                                        {/* 小时 */}
                                        {
                                            UdeskLocales['current'].pages.tasks.manage.template
                                                .automaticAdd.templateNew.hours
                                        }
                                    </span>
                                </span>

                                <span style={{ marginLeft: '20px' }}>
                                    <Checkbox
                                        checked={refreshComplainPeriodAndNum === 1}
                                        onChange={(e) =>
                                            onValueChanged?.(
                                                'refreshComplainPeriodAndNum',
                                                e.target.checked ? 1 : 0
                                            )
                                        }
                                        disabled={disabled}
                                    >
                                        {/* 抽检或重新质检时刷新申诉有效期 */}
                                        {
                                            UdeskLocales['current'].pages.tasks.manage.template
                                                .automaticAdd.components.businessConfig.index
                                                .refreshTheAppealValidityPeriodDuringRandomInspectionOrReinspection
                                        }
                                    </Checkbox>
                                </span>
                            </div>
                        ) : complainPeriodMode === AppealConfigModeMap.CutOff ? (
                            <div>
                                <Space wrap>
                                    <div>
                                        {/* 申诉截止时间 */}
                                        {
                                            UdeskLocales['current'].pages.tasks.manage.template
                                                .automaticAdd.components.businessConfig.index
                                                .complaintDeadline
                                        }
                                    </div>
                                    <Frequency
                                        value={{
                                            frequency: complainCycle,
                                            day: complainScope,
                                            week: complainScope,
                                            time: complainDeadTime,
                                        }}
                                        onChange={(e) => {
                                            onValueChanged?.('complainCycle', e?.frequency);
                                            onValueChanged?.(
                                                'complainScope',
                                                e?.frequency ===
                                                    Udesk.enums.assessFrequencyTypes.everyWeek.id
                                                    ? e?.week
                                                    : e?.day
                                            );
                                            onValueChanged?.('complainDeadTime', e?.time);
                                        }}
                                        hideFrequencyeList={[
                                            Udesk.enums.assessFrequencyTypes.everyDay.id,
                                        ]}
                                    />
                                    <div>
                                        {/* 复核截止时间 */}
                                        {
                                            UdeskLocales['current'].pages.tasks.manage.template
                                                .automaticAdd.components.businessConfig.index
                                                .reviewDeadline
                                        }
                                    </div>
                                    <Frequency
                                        value={{
                                            frequency: reviewCycle,
                                            day: reviewScope,
                                            week: reviewScope,
                                            time: reviewDeadTime,
                                        }}
                                        onChange={(e) => {
                                            onValueChanged?.('reviewCycle', e?.frequency);
                                            onValueChanged?.(
                                                'reviewScope',
                                                e?.frequency ===
                                                    Udesk.enums.assessFrequencyTypes.everyWeek.id
                                                    ? e?.week
                                                    : e?.day
                                            );
                                            onValueChanged?.('reviewDeadTime', e?.time);
                                        }}
                                        hideFrequencyeList={[
                                            Udesk.enums.assessFrequencyTypes.everyDay.id,
                                        ]}
                                        allowFrequencyClear
                                    />
                                    <div>
                                        {/* 允许提交申诉次数 */}
                                        {
                                            UdeskLocales['current'].pages.tasks.manage.template
                                                .automaticAdd.components.businessConfig.index
                                                .numberOfAppealsAllowedToBeSubmitted
                                        }
                                    </div>
                                    <InputNumber
                                        value={complainDeadCount}
                                        onChange={(e) => onValueChanged?.('complainDeadCount', e)}
                                        disabled={disabled}
                                        min={1}
                                        precision={0}
                                    />
                                    {/* 次 */}
                                    {
                                        UdeskLocales['current'].pages.tasks.manage.template
                                            .automaticAdd.components.businessConfig.index.second
                                    }
                                </Space>
                            </div>
                        ) : null}

                        <div>
                            <Checkbox.Group
                                value={Object.keys(appealOptionsExport).filter(
                                    (i) => appealOptionsExport[i]
                                )}
                                onChange={onAppealValueChanged}
                                disabled={disabled}
                                style={{ width: '100%' }}
                            >
                                <Row>
                                    {appealOptionsList?.map((item) => {
                                        return (
                                            <Col span={8}>
                                                <Checkbox key={item.key} value={item.key}>
                                                    {item.label}
                                                </Checkbox>
                                            </Col>
                                        );
                                    })}
                                </Row>
                            </Checkbox.Group>
                        </div>

                        <div>
                            <Checkbox.Group
                                value={Object.keys(appaelable).filter((i) => appaelable[i])}
                                onChange={onAppealableChanged}
                                disabled={disabled}
                                style={{ width: '100%' }}
                            >
                                <Row>
                                    {appealableOptionsList?.map((item) => {
                                        return (
                                            <Col span={8}>
                                                <Checkbox key={item.key} value={item.key}>
                                                    {item.label}
                                                </Checkbox>
                                            </Col>
                                        );
                                    })}
                                </Row>
                            </Checkbox.Group>
                        </div>
                    </div>
                </div>
            ) : null}

            {/* 详情显示配置 */}
            <div className="automatic-content-item-body-item">
                <div className="automatic-content-item-body-item-title">
                    {/* 详情显示配置： */}
                    {
                        UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.templateNew
                            .detailDisplayConfiguration
                    }
                </div>
                <div
                    className="automatic-content-item-body-item-content"
                    style={{ width: 'calc(100% - 132px)', lineHeight: '30px' }}
                >
                    <div>
                        <Checkbox.Group
                            value={callDetailShowConfigList}
                            disabled={disabled}
                            style={{ width: '100%' }}
                            onChange={callDetaiConfigChanged}
                        >
                            <Row>
                                {callDetailShowConfigOption?.map((item, index) => {
                                    return (
                                        <Col span={12}>
                                            <Checkbox key={item.key} value={item.key}>
                                                {item.label}
                                            </Checkbox>
                                            {index === 0 && (
                                                <span>
                                                    <span>
                                                        {/* 静默超过 */}
                                                        {
                                                            UdeskLocales['current'].pages.tasks
                                                                .manage.template.automaticAdd
                                                                .templateNew.silenceOver
                                                        }
                                                    </span>
                                                    <span>
                                                        <InputNumber
                                                            value={overSecondsDurationShow}
                                                            onChange={(e) =>
                                                                onValueChanged?.(
                                                                    'overSecondsDurationShow',
                                                                    e
                                                                )
                                                            }
                                                            disabled={disabled}
                                                        />
                                                        {/* 秒时显示 */}
                                                        {
                                                            UdeskLocales['current'].pages.tasks
                                                                .manage.template.automaticAdd
                                                                .templateNew.displayAtSeconds
                                                        }
                                                    </span>
                                                </span>
                                            )}
                                        </Col>
                                    );
                                })}
                            </Row>
                        </Checkbox.Group>
                    </div>
                </div>
            </div>

            <div className="automatic-content-item-body-item">
                <div className="automatic-content-item-body-item-title">
                    {/* 终审配置： */}
                    {
                        UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.components
                            .businessConfig.index.finalConfiguration
                    }
                </div>

                <div
                    className="automatic-content-item-body-item-content"
                    style={{ width: 'calc(100% - 132px)', lineHeight: '30px' }}
                >
                    <Checkbox
                        checked={finalReview === 1}
                        onChange={(e) => onValueChanged?.('finalReview', e.target.checked ? 1 : 0)}
                        disabled={disabled}
                    >
                        {/* 允许在质检详情中进行终审 */}
                        {
                            UdeskLocales['current'].pages.tasks.manage.template.automaticAdd
                                .components.businessConfig.index.allowFinalReviewInQualityDetails
                        }
                    </Checkbox>
                </div>
            </div>

            <div className="automatic-content-item-body-item">
                <div className="automatic-content-item-body-item-title">
                    {/* 案例库配置： */}
                    {
                        UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.components
                            .businessConfig.index.caseLibraryConfiguration
                    }
                </div>

                <div
                    className="automatic-content-item-body-item-content"
                    style={{ width: 'calc(100% - 132px)', lineHeight: '30px' }}
                >
                    <Checkbox
                        checked={sdkShowCaseLibrary === 1}
                        onChange={(e) =>
                            onValueChanged?.('sdkShowCaseLibrary', e.target.checked ? 1 : 0)
                        }
                        disabled={disabled}
                    >
                        {/* 允许在申诉SDK中查看案例库 */}
                        {
                            UdeskLocales['current'].pages.tasks.manage.template.automaticAdd
                                .components.businessConfig.index
                                .allowViewingTheCaseLibraryInTheAppealsSDK
                        }
                    </Checkbox>
                </div>
            </div>

            {/* 备注模板 */}
            <div className="automatic-content-item-body-item">
                <div className="automatic-content-item-body-item-title">
                    {UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.index
                        .remarkTemplate + '：'}
                </div>
                <div
                    className="automatic-content-item-body-item-content"
                    style={{ width: 'calc(100% - 132px)', lineHeight: '30px' }}
                >
                    <Input.TextArea
                        onChange={onRemarkModelChange}
                        showCount={true}
                        maxCount={1000}
                        value={remarkModel}
                        autoSize={{ minRows: 4, maxRows: 6 }}
                        disabled={disabled}
                    />
                </div>
            </div>
        </>
    );
};

export default Template;
